import { render } from "./LoadingData.vue?vue&type=template&id=a9af232e"
import script from "./LoadingData.vue?vue&type=script&lang=js"
export * from "./LoadingData.vue?vue&type=script&lang=js"

import "./LoadingData.vue?vue&type=style&index=0&id=a9af232e&lang=scss"

import exportComponent from "../../../motom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__